module.exports = __webpack_public_path__ + "img/yuanjing.48efba53.png";